import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserDoctor, faChild, faHeadphones } from '@fortawesome/free-solid-svg-icons';
import './VisitePage.css';

const VisitePage: React.FC = () => {
  const visits = [
    {
      icon: faUserDoctor,
      title: 'Visita Otorinolaringoiatrica',
      description: 'Esame completo di orecchi, naso e gola per adulti. Diagnosi e trattamento delle principali patologie ORL.',
      link: '/visite/otorinolaringoiatrica'
    },
    {
      icon: faChild,
      title: 'Visita Otorinolaringoiatrica Pediatrica',
      description: 'Visita specialistica dedicata ai bambini, con particolare attenzione alle problematiche dell\'età pediatrica.',
      link: '/visite/pediatrica'
    },
    {
      icon: faHeadphones,
      title: 'Visita Audiologica',
      description: 'Valutazione completa dell\'udito con esami strumentali per diagnosi e trattamento dei disturbi uditivi.',
      link: '/visite/audiologica'
    }
  ];

  return (
    <div className="visite-page">
      {/* Header Section */}
      <section className="visite-header">
        <div className="visite-header-container">
          <p className="visite-header-label">LE NOSTRE VISITE</p>
          <h1 className="visite-header-title">
            Tipologie di<br />
            <span className="visite-header-accent">Visite Specialistiche</span>
          </h1>
          <p className="visite-header-description">
            Offriamo diverse tipologie di visite specialistiche per rispondere 
            alle esigenze di pazienti di tutte le età.
          </p>
        </div>
      </section>

      {/* Image Section */}
      <section className="visite-image-section">
        <div className="visite-image-container">
          <img 
            src={require("../assets/carousel/PHOTO-2025-10-16-20-09-04.jpg")} 
            alt="Studio medico"
            className="visite-header-image" 
          />
        </div>
      </section>

      {/* Visits Cards Section */}
      <section className="visite-cards-section">
        <div className="visite-cards-container">
          {visits.map((visit, index) => (
            <Link 
              key={index} 
              to={visit.link} 
              className="visit-card"
            >
              <div className="visit-card-icon">
                <FontAwesomeIcon icon={visit.icon} />
              </div>
              <h3 className="visit-card-title">{visit.title}</h3>
              <p className="visit-card-description">{visit.description}</p>
              <span className="visit-card-link">Scopri di più →</span>
            </Link>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="visite-cta">
        <div className="visite-cta-container">
          <h2 className="visite-cta-title">Hai bisogno di una visita?</h2>
          <p className="visite-cta-description">
            Contattaci per prenotare la tua visita specialistica o per ricevere 
            maggiori informazioni.
          </p>
          <Link to="/#prenota" className="btn-primary">Prenota Ora</Link>
        </div>
      </section>
    </div>
  );
};

export default VisitePage;
